import { Box, Typography, Button, CircularProgress, Link } from '@mui/material'
import { LoginFormClasses, TextInput } from "react-admin"
import { Form, Dispatch, required, useNotify, useSafeSetState, useTranslate } from 'ra-core'
import logo from './../resources/freeBILL_logo.png'
import { SetStateAction } from 'react'
import SecondFactorLogin, { SecondFactor } from './SecondFactorLogin'
import { LoginPageType } from './LoginPage'
import useLoginCustom from './useLoginCustom'

const Login = ({setPage}: {setPage: Dispatch<SetStateAction<LoginPageType>>}) => {
  
  const [loading, setLoading] = useSafeSetState(false)
  const [secondFactor, setSecondFactor] = useSafeSetState<SecondFactor | undefined>()
  const translate = useTranslate()
  const login = useLoginCustom()
  const notify = useNotify()
  
  const submit = async(values: any) => {

    setLoading(true);
    login({loginType: "login", username: values.username, password: values.password})
      .then(() => {
        setLoading(false);
      })
      .catch(error => {
          setLoading(false)
          if(error.reason === "SecondFactorMissing")
          {
            setSecondFactor({authKey: error.authKey, userId: error.userId})
          } else {
            notify(
              typeof error === 'string'
                  ? error
                  : typeof error === 'undefined' || !error.message
                  ? 'ra.auth.sign_in_error'
                  : error.message,
              {
                  type: 'error',
                  messageArgs: {
                      _:
                          typeof error === 'string'
                              ? error
                              : error && error.message
                              ? error.message
                              : undefined,
                  },
              }
            )
          }            
      })
  }

  return (
    <Box p={5} display={"flex"} height={450} width={"100%"} sx={{backgroundColor: "#f3f3fa"}} justifyContent={"center"}>
      <Box width={{xs: "100%", sm: "60%", md: "30%"}}>
        <Box display={"flex"} justifyContent={"center"} >
          <Box 
            component={"img"}
            sx={{height: 45}}
            src={logo}
            display={{xs: "none", sm: "block"}}
          />
        </Box>
        <Box py={2}>
        <Form
          //@ts-ignore
          onSubmit={submit}
          mode="onChange"
          noValidate
        >
          <TextInput
              autoFocus
              source="username"
              label={translate('ra.auth.username')}
              autoComplete="username"
              validate={required()}
              fullWidth
          />
          <TextInput
              source="password"
              label={translate('ra.auth.password')}
              type="password"
              validate={required()}
              autoComplete="current-password"
              fullWidth
          />

          <Button
              variant={"contained"}
              type="submit"
              disabled={loading}
              fullWidth
              className={LoginFormClasses.button}
              size='small'
          >
              {loading ? (
                  <CircularProgress
                      className={LoginFormClasses.icon}
                      size={19}
                      thickness={3}
                  />
              ) : (
                  translate('ra.auth.sign_in')
              )}
          </Button>
        </Form>
        </Box>
        <Box display={"flex"} justifyContent={"center"}>
          <Link sx={{cursor: "pointer"}} onClick={() => setPage("sendResetPassword")}>{translate("resources.authentication.login.resetPassword")}</Link>
        </Box>
        <Box py={2} display={"flex"} justifyContent={"center"}>
          <Typography>{translate("resources.authentication.login.notRegistered")} {<Link sx={{cursor: "pointer"}} onClick={() => setPage("register")}>{translate("resources.authentication.login.register")}</Link>}</Typography>
        </Box>
      </Box>  
      <SecondFactorLogin secondFactor={secondFactor} setSecondFactor={setSecondFactor} />
    </Box>
  )
}

export default Login